import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AllCompaniesComponent } from './all-companies/all-companies.component';

export const routes: Routes = [
        { path: '', redirectTo: 'home', pathMatch: 'full' },
        { path: 'home', component: HomeComponent },
        { path: 'casa', component: HomeComponent },
        { path: 'all-companies', component: AllCompaniesComponent },
        { path: 'tutte-le-aziende', component: AllCompaniesComponent }
];
